const buttonStyleBase = {
  width: '180px',
  height: '40px',
  borderRadius: '5px',
  fontSize: '0.75rem',
};
const styles = theme => ({
  dialogPaper: {
    padding: '20px',
    position: 'relative',
  },
  closeIconSection: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '60px',
    width: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    color: '#000000',
  },
  contentParent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 60px',
    minWidth: '407px',
  },
  dialogImage: {
    marginTop: '50px',
  },
  dialogTitle: {
    fontSize: '25px',
    fontFamily: 'circe-rounded',
    fontWeight: '700',
    margin: '26px 0 0 0',
  },
  searchableSelectParent: {
    alignSelf: 'stretch',
    margin: '15px 0 0 0',
  },
  searchableFieldTitle: {
    margin: '0 0 4px 0',
    fontWeight: '700',
  },
  primaryButton: {
    ...buttonStyleBase,
    color: '#ffffff',
    backgroundColor: '#e0592a',
    margin: '30px 0 0 0',
    '&:hover': {
      backgroundColor: '#ff875e',
    },
  },
  cancelButton: {
    ...buttonStyleBase,
    color: '#000000',
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    margin: '10px 0 0 0',
  },
});

export {
  styles,
};
